import { useFlags } from '@atlaskit/flag';
import { AcknowledgeAlertFormFields } from 'core/config/form-fields';
import { useDialog } from 'core/providers/DialogProvider';
import { showErrorFlag, showSuccessFlag } from 'core/utilities/flags-helper';
import { useState } from 'react';
import { IButton } from 'shared/components/buttons/button-interface';
import SharedDialogBase from 'shared/components/dialog-base/dialog-base';
import SharedForm from 'shared/components/form/form';
import { AlertsApiService } from 'core/api';
import { useAuthState } from 'core/providers/AuthProvider';
import { IAlertDao } from 'core/api/types/alerts.interface';
import { Timestamp } from 'firebase/firestore';
import { IUpdateDataPayload } from 'core/api/api.service';

const AcknowledgeAlertDialog = ({ alert }: { alert: IAlertDao }) => {
  const { userData } = useAuthState();
  const flags = useFlags();
  const dialog = useDialog();

  const [formSubmitting, setFormSubmitting] = useState(false);

  const acknowledgeAlert = async (data: IAlertDao) => {
    setFormSubmitting(true);

    const payload: IUpdateDataPayload<IAlertDao> = {
      acknowledged: {
        at: Timestamp.now(),
        by: {
          fullName: userData?.fullName ?? '',
          uid: userData?.uid ?? '',
        },
      },
      comment: data.comment,
    };

    console.log(alert);

    try {
      await AlertsApiService.update(alert.uid, payload, {
        fullName: userData?.fullName ?? '',
        uid: userData?.uid ?? '',
      });
      showSuccessFlag('Alert acknowledged', `The alert has been acknowledged successfully`, flags);
      dialog?.closeDialog();
    } catch (error) {
      console.log(error);
      showErrorFlag('Alert acknowledgement failed', `Unable to acknowledge the alert, please try again.`, flags);
      setFormSubmitting(false);
    }
  };

  const cancelButton: IButton = {
    onClick: () => dialog?.closeDialog(),
    label: 'Cancel',
    appearance: 'subtle',
    type: 'button',
  };

  const customContent = () => {
    return (
      <SharedForm
        className='p-4 overflow-y-auto'
        onSubmit={acknowledgeAlert}
        fields={AcknowledgeAlertFormFields}
        buttonLabel='Submit'
        loading={formSubmitting}
        cancelButton={cancelButton}
      />
    );
  };

  return <SharedDialogBase title='Acknowledge alert' customContentTemplate={customContent()} showButtons={false} />;
};

export default AcknowledgeAlertDialog;
